import { render, staticRenderFns } from "./doctor_profile.vue?vue&type=template&id=e0f10fee&"
import script from "./doctor_profile.vue?vue&type=script&lang=js&"
export * from "./doctor_profile.vue?vue&type=script&lang=js&"
import style0 from "./doctor_profile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports